// 通用配置
import { EDRAWMAX_PRODUCT_ENV, EDRAWMAX_PRODUCT_API } from "./global";

let EDRAWMAX_USE_SENSOR = !!~~process.env.EDRAWMAX_USE_SENSOR || false;
let EDRAWMAX_USE_BAIDUTRACK = !!~~process.env.EDRAWMAX_USE_BAIDUTRACK || false;
let EDRAWMAX_USE_GOOGLETRACK = !!~~process.env.EDRAWMAX_USE_GOOGLETRACK || false;
let EDRAWMAX_HELP_URL = process.env.EDRAWMAX_HELP_URL || EDRAWMAX_PRODUCT_API;
let EDRAWMAX_WXREDIRECT =
    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwe1173c8b797fc26c&redirect_uri=t.edrawmax.cn/app/&response_type=code&scope=snsapi_privateinfo&agentid=ww220f69fdc8d5b525&state=STATE#wechat_redirect";
let EDRAWMAX_OSSID = "temp";

if (EDRAWMAX_PRODUCT_ENV == "production" || EDRAWMAX_PRODUCT_ENV == "test37") {
    EDRAWMAX_USE_SENSOR = true;
    EDRAWMAX_USE_BAIDUTRACK = true;
    EDRAWMAX_USE_GOOGLETRACK = true;
}
EDRAWMAX_OSSID = EDRAWMAX_PRODUCT_ENV == "test37" ? "LTAI5tFdp5HasJiCfurNa7TF" : "LTAI4GFsnfHsuX1sdmp55MsK";

export { EDRAWMAX_USE_SENSOR, EDRAWMAX_USE_BAIDUTRACK, EDRAWMAX_USE_GOOGLETRACK, EDRAWMAX_HELP_URL, EDRAWMAX_WXREDIRECT, EDRAWMAX_OSSID };
